import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'zs-icon',
  templateUrl: './zs-icon.component.html',
  styleUrls: ['./zs-icon.component.scss']

})
export class ZsIconComponent implements OnInit {

  @Input()
  name!: string;

  constructor() { }

  ngOnInit(): void {
  }

}
